<caremoni-dialog-template id="answer-dialog" [dialogTemplate]="dialogTemplate" (closeModalHandler)="closeModal()">
    <div modal-body>
        <div class="dialog-container">
            <p class="dialog-description">ケアモニに表示する回答項目を選択してください</p>
            <div class="dropdown"><span>{{condition.itemname}}</span></div>
            <!-- Answer Tag -->
            <div class="tag-section">
                <div>
                    <div class="table-box">
                        <div class="table-title table-title-left w-50 table-title-disable">回答タグ</div>
                        <div class="table-title table-title-right w-50 table-title-disable">回答プレビュー</div>
                    </div>
                    <div *ngFor="let answer of answerLst" class="table-box">
                        <div class="w-50 row-left">
                            <div (click)="selectAnswer(answer)" [ngClass]="answer.selected"  class="table-row {{styleDisableRow}}">{{answer?.atag}}</div>
                        </div>
                        <div class="w-50 row-right">
                            <div [ngClass]="answer.selected" class="table-row table-row-disable">{{answer?.lbl}}</div>
                        </div>
                        <!-- <div *ngFor="let an swer of answerLst" class="tag-list">
                                            <div class="tag-item" (click)="selectAnser(answer)" [ngClass]="answer.selected">{{answer.lbl}}</div>
                                        </div> -->
                    </div>
                </div>
            </div>
            <!-- User condition -->
            <div class="condition-section">
                <div class="d-flex">
                    <label class="condition-label">ユーザー詳細設定</label>
                    <label class="condition-label condition-toggle"  [class.disabled]="isDisableSelect" [class.hover-off]="isHoverToggleOff" (mousemove)="onToggleMouseMove()" (click)="showTabOption()">{{symbolShowOptionSelect}}</label>
                </div>
                <div *ngIf="isShowOptionSelect" class="condition">
                    <div class="d-flex l-h-24">
                        <div class="d-flex">
                            <caremoni-radio-button [isChecked]="optionLst[0].checked" (click)="pickOption(optionLst[0].option)"></caremoni-radio-button>
                            <!-- <caremoni-checkbox [value]="optionLst[0].checked" (click)="pickOption(optionLst[0].option)"></caremoni-checkbox> -->
                            <label class="ml-2 dlgu-txt pd-bot-5">&nbsp; 回答値</label>
                        </div>
                        <caremoni-select-box class="select-ans-type select-answer-condition-type" [options]="optionOneTypeOptions" [panelMinWidth]="170"
                            [selectedValue]="optionOneSelected" [disabled]="!optionLst[0].checked"
                            (valueChange)="optionOneSelected = $event">
                        </caremoni-select-box>
                    </div>
                    <!-- <p class="p-1"></p>
                    <div class="d-flex l-h-24">
                        <div class="d-flex"><caremoni-checkbox [value]="optionLst[1].checked" (click)="pickOption(optionLst[1].option)"></caremoni-checkbox></div>
                        <label class="ml-2 dlgu-txt pd-bot-5">&nbsp; 回答があれば連携</label>
                        <div class="px-1 pt-1"><div class="title-chip" pTooltip="{{TT_30}}" tooltipPosition="right">?</div></div>
                    </div> -->
                    <p class="p-1"></p>
                    <div class="d-flex l-h-24">
                        <div class="d-flex">
                            <caremoni-radio-button [isChecked]="optionLst[2].checked" (click)="pickOption(optionLst[2].option)"></caremoni-radio-button>
                            <!-- <caremoni-checkbox [value]="optionLst[2].checked" (click)="pickOption(optionLst[2].option)"></caremoni-checkbox> -->
                            <label class="ml-2 dlgu-txt pd-bot-5">&nbsp; フリーワードを指定する</label>
                        </div>
                        <div class="px-1 pt-1"><div class="title-chip" pTooltip="{{TT_31}}" tooltipPosition="right">?</div></div>
                    </div>
                    <p class="p-1"></p>
                    <div class="condition-input l-h-24">
                        <div class="text-select-group">
                            <input type="text" [(ngModel)]="answersThree" [disabled]="isDiableOption" placeholder="テキストを入力"
                                (focus)="onSettingInputFocus()" (blur)="onSettingInputBlur()" />を
                            <caremoni-select-box class="select-ans-type" [options]="optionThreeTypeOptions"
                                [selectedValue]="optionThreeSelected" [disabled]="!optionLst[2].checked"
                                (valueChange)="optionThreeSelected = $event"></caremoni-select-box>
                        </div>
                    </div>
                    <div *ngIf="this.title?.colname == 'elapsed_time'">
                            <p class="p-1"></p>
                            <p class="p-1"></p>
                            <div class="d-flex l-h-24">
                                <div class="d-flex">
                                    <caremoni-radio-button [isChecked]="optionLst[3].checked"
                                        (click)="pickOption(optionLst[3].option)"></caremoni-radio-button>
                                    <!-- <caremoni-checkbox [value]="optionLst[3].checked" (click)="pickOption(optionLst[3].option)"></caremoni-checkbox> -->
                                    <label class="ml-2 dlgu-txt pd-bot-5">&nbsp; フリーワードと回数を指定する</label>
                                </div>
                                <div class="px-1 pt-1">
                                    <div class="title-chip" pTooltip="{{TT_31}}" tooltipPosition="right">?</div>
                                </div>
                            </div>
                            <p class="p-1"></p>
                            <ng-container *ngFor="let timeData of elapsedTimeData">
                                <caremoni-elapsed-time [data]="timeData" [disabled]="isDisableElapsedTime"
                                    [isDeleteVisible]="elapsedTimeData.length > 1" (onDeleteRow)="deleteElapsedTimeRow($event)"
                                    (onInputFocus)="onSettingInputFocus()" (onInputBlur)="onSettingInputBlur()">
                                </caremoni-elapsed-time>
                            </ng-container>
                            <p class="p-1"></p>
                            <p class="p-1"></p>
                            <button [disabled]="isDisableElapsedTime || elapsedTimeData.length >= elapsedMaxLength" class="btn add"
                                [ngClass]="{ disabled: isDisableElapsedTime }" (click)="addElapsedTime()">{{BUTTON.ADD}}
                            </button>
                            </div>
                    </div>
            </div> 
        </div>
    </div>

    <div modal-footer>
        <div class="button-group">
            <a class="btn cancel" (click)="closeModal()">キャンセル</a>
            <button class="btn save" (click)="saveAns()">保存</button>
        </div>
    </div>
</caremoni-dialog-template>
